import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs";
import { OrganizationKeyName } from "../model/Organization";
import { getAuthAndDefaultHeaders } from "./apiConsts";
import { OnlinePosCampaignListSuccessResponse } from "./api-response/OnlinePosCampaignListSuccessResponse";
import { map } from "rxjs/operators";

export class ApiOnlinePos {
  constructor(private apiEndpoint: string) {}

  getPosCampaignListWithAvailableFlag(
    token: string,
    organization: OrganizationKeyName
  ): Observable<OnlinePosCampaignListSuccessResponse> {
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/online-pos/campaigns?mark_available=1`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }
}
